import { jsxs, jsx } from 'react/jsx-runtime';

const toDigits = (value) => value.replace(/\D/g, '');
const usPhoneMask = {
    format: (digits) => {
        const trimmed = digits.slice(0, 10);
        if (trimmed.length === 0)
            return '';
        if (trimmed.length <= 3)
            return `(${trimmed})`;
        if (trimmed.length <= 6)
            return `(${trimmed.slice(0, 3)}) ${trimmed.slice(3)}`;
        return `(${trimmed.slice(0, 3)}) ${trimmed.slice(3, 6)}-${trimmed.slice(6)}`;
    },
    normalize: (displayValue) => toDigits(displayValue).slice(0, 10),
};
const UsFlag = (jsxs("svg", { width: "22", height: "16", viewBox: "0 0 22 16", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", children: [jsxs("defs", { children: [jsx("polygon", { id: "s", fill: "#fff", points: "0,-0.4 0.12,-0.12 0.38,-0.12 0.17,0.04 0.25,0.3 0,0.14 -0.25,0.3 -0.17,0.04 -0.38,-0.12 -0.12,-0.12" }), jsxs("g", { id: "r6", children: [jsx("use", { href: "#s", x: "1" }), jsx("use", { href: "#s", x: "3" }), jsx("use", { href: "#s", x: "5" }), jsx("use", { href: "#s", x: "7" }), jsx("use", { href: "#s", x: "9" }), jsx("use", { href: "#s", x: "11" })] }), jsxs("g", { id: "r5", children: [jsx("use", { href: "#s", x: "2" }), jsx("use", { href: "#s", x: "4" }), jsx("use", { href: "#s", x: "6" }), jsx("use", { href: "#s", x: "8" }), jsx("use", { href: "#s", x: "10" })] })] }), jsx("rect", { width: "21.33", height: "16", fill: "#BD3D44" }), jsx("path", { d: "M0,1.23h21.33v1.23H0ZM0,3.68h21.33v1.23H0ZM0,6.15h21.33v1.23H0ZM0,8.62h21.33v1.23H0ZM0,11.08h21.33v1.23H0ZM0,13.55h21.33v1.23H0", fill: "#fff" }), jsx("rect", { width: "12.16", height: "8.62", fill: "#192F5D" }), jsxs("g", { y: "0.4", children: [jsx("use", { href: "#r6", y: "0.4" }), jsx("use", { href: "#r5", y: "1.25" }), jsx("use", { href: "#r6", y: "2.11" }), jsx("use", { href: "#r5", y: "2.97" }), jsx("use", { href: "#r6", y: "3.83" }), jsx("use", { href: "#r5", y: "4.69" }), jsx("use", { href: "#r6", y: "5.55" }), jsx("use", { href: "#r5", y: "6.41" }), jsx("use", { href: "#r6", y: "7.27" })] })] }));
const countryList = [
    {
        value: 'US',
        icon: UsFlag,
        dialCode: '+1',
        label: 'United States',
        mask: usPhoneMask,
    },
];

export { countryList };
